import { emptyPoint } from './classify-customer-movements';
import type { ChartPeriodMode, MrrMovementChartDataPoint } from './types';

export function aggregateByPeriod(
  monthly: MrrMovementChartDataPoint[],
  mode: ChartPeriodMode,
): MrrMovementChartDataPoint[] {
  if (mode === 'monthly') {
    return monthly;
  }
  if (mode === 'quarterly') {
    return aggregateToBucket(monthly, getQuarterLabel);
  }
  return aggregateToBucket(monthly, getAnnualLabel);
}

function aggregateToBucket(
  monthly: MrrMovementChartDataPoint[],
  getBucketLabel: (monthLabel: string) => string,
): MrrMovementChartDataPoint[] {
  const bucketMap = new Map<string, MrrMovementChartDataPoint>();
  const orderedBuckets: MrrMovementChartDataPoint[] = [];

  for (const point of monthly) {
    const label = getBucketLabel(point.label);
    let bucket = bucketMap.get(label);

    if (!bucket) {
      bucket = emptyPoint(label);
      bucket.beginningMrr = point.beginningMrr;
      bucketMap.set(label, bucket);
      orderedBuckets.push(bucket);
    }

    bucket.new += point.new;
    bucket.expansion += point.expansion;
    bucket.reactivation += point.reactivation;
    bucket.contraction += point.contraction;
    bucket.churn += point.churn;
    bucket.netNewMrr += point.netNewMrr;
    bucket.endingMrr = point.endingMrr;
  }

  return orderedBuckets;
}

const MONTH_QUARTERS: Record<string, number> = {
  Jan: 1,
  Feb: 1,
  Mar: 1,
  Apr: 2,
  May: 2,
  Jun: 2,
  Jul: 3,
  Aug: 3,
  Sep: 3,
  Oct: 4,
  Nov: 4,
  Dec: 4,
};

function getQuarterLabel(monthLabel: string): string {
  const [abbrev, year] = monthLabel.split(' ');
  const quarter = MONTH_QUARTERS[abbrev];
  return quarter ? `Q${quarter} ${year}` : monthLabel;
}

function getAnnualLabel(monthLabel: string): string {
  // "Jul 25" → "2025": the annual axis shows the full year, not a cramped "25".
  const year = monthLabel.split(' ')[1];
  if (!year) return monthLabel;
  return year.length === 2 ? `20${year}` : year;
}
